// import stub from '../stubs/Vendors'

const defaultState = {};
// const defaultState = stub

export default function vendorReducer(state = defaultState, action) {
  switch (action.type) {
    case 'FETCH_VENDOR_INITIATED': {
      return {
        ...state,
        is_fetching: true,
        slug: action.slug,
      };
    }
    case 'FETCH_VENDOR_COMPLETED':
      return {
        ...action.vendor,
        similarVendors: action.similarVendors,
        is_fetching: false,
      };
    case 'FETCH_VENDOR_FAILED':
      return {
        ...state,
        fetch_failed: true,
        is_fetching: false,
      };
    case 'SEND_ENQUIRY_INITIATED': {
      return {
        ...state,
        is_sending_message: true,
      };
    }
    case 'SEND_ENQUIRY_COMPLETED': {
      return {
        ...state,
        is_sending_message: false,
      };
    }
    default:
      return state;
  }
}
